module.exports = __webpack_public_path__ + "img/loopbrug.cb110f8b.jpg";